import { useCallback, useState } from "react";
import { ROUTES as API_ROUTES } from "../../constants/api";
import { GetApiData } from "../../api/general";
import useErrorModal from "../useErrorModal";

// types
import type { SendMoneyWorkflowResponse } from "../../types/api/sendMoney";
import type { SendMoneyTransferMethodId, SendMoneyWorkflow } from "../../types/sendMoney";

interface FetchWorkflowParams {
  methodId: SendMoneyTransferMethodId;
  sendingToSelf: boolean;
  quoteId: number;
  operatorId?: number;
}

const useGetWorkflow = () => {
  const openErrorModal = useErrorModal();
  const [loading, setLoading] = useState(false);

  const fetchWorkflow = useCallback(
    async (params: FetchWorkflowParams): Promise<SendMoneyWorkflow | null> => {
      try {
        setLoading(true);
        const url = API_ROUTES.SEND_MONEY.GET_WORKFLOW(
          params.methodId,
          params.sendingToSelf,
          params.quoteId,
          params.operatorId
        );
        const response = await GetApiData<SendMoneyWorkflowResponse>(url);
        return response.result;
      } catch (err) {
        openErrorModal(err);
        return null;
      } finally {
        setLoading(false);
      }
    },
    []
  );

  return { loading, fetchWorkflow };
};

export default useGetWorkflow;